<template>
    <AppHeader />
    <router-view />
</template>

<script>
import { getUserInfo } from "@/service/account";
import { getSystemConfig } from "@/service/system";
import AppHeader from "@/components/AppHeader.vue";
import { ElMessageBox } from "element-plus";

export default {
    name: "App",
    components: {
        AppHeader,
    },
    data() {
        return {
            bindWechatPromptVisible: false,
        };
    },
    computed: {
        token() {
            return this.$route.query.token || localStorage.getItem("token");
        },
    },
    watch: {
        "$route.query.token": {
            handler(val) {
                if (!val) return;

                localStorage.setItem("token", val);
                this.$store.commit("setToken", val);

                getUserInfo(val).then((res) => {
                    const profile = res.data.data || {};
                    this.$store.commit("SET_USER_INFO", profile);

                    if (this.shouldPromptBindWechat(profile)) {
                        this.promptBindWechat();
                    }
                });
            },
            immediate: true,
        },
    },
    methods: {
        shouldPromptBindWechat(profile) {
            if (profile.wx_mp_openid) return false;
            if (this.bindWechatPromptVisible) return false;
            return this.$route.name !== "user_wechat";
        },
        promptBindWechat() {
            this.bindWechatPromptVisible = true;
            ElMessageBox.confirm(this.$t("app.bindWechatPrompt"), this.$t("app.tip"), {
                confirmButtonText: this.$t("app.goBind"),
                cancelButtonText: this.$t("common.cancel"),
                type: "warning",
            })
                .then(() => {
                    this.$router.push({ name: "user_wechat" });
                })
                .catch(() => {})
                .finally(() => {
                    this.bindWechatPromptVisible = false;
                });
        },
        async loadPhone(key = "express_phone_sys") {
            try {
                const cachedPhone = sessionStorage.getItem(key);
                if (cachedPhone) {
                    this.$store.commit("SET_STATE", { key, value: cachedPhone });
                    return;
                }

                const phone = await getSystemConfig(key, this.token).then((res) => {
                    return res.data?.data || "";
                });
                this.$store.commit("SET_STATE", { key, value: phone });
                sessionStorage.setItem(key, phone);
            } catch (error) {
                console.error(error);
            }
        },
    },
    mounted() {
        if (this.token) {
            this.loadPhone();
            this.loadPhone("express_phone_erp");
        }
    },
};
</script>
